const PmdWrapper = () => import('@/pages/chargeManagement/wrapper.vue');
const PmdTab = () => import('../pages/PartyMembershipDues/PmdTab');
const PmdDetailsEmpty = () => import('../pages/PartyMembershipDues/PmdDetailsEmpty');
const PmdChargeSchedule = () => import('../pages/PartyMembershipDues/PmdChargeSchedule');
const PmdClearedList = () => import('../pages/PartyMembershipDues/PmdClearedList');
const PmdRefund = () => import('../pages/PartyMembershipDues/PmdRefund');
const PmdRefundRecord = () => import('../pages/PartyMembershipDues/PmdRefundRecord');
const PmdRefundRecordDetail = () => import('../pages/PartyMembershipDues/PmdRefundRecordDetail');
const PmdDetailsTemplateIssue = () => import('../pages/PartyMembershipDues/PmdDetailsTemplateIssue');
const PmdImportXH = () => import('../pages/PartyMembershipDues/PmdImportXH');
const PmdImportSJH = () => import('../pages/PartyMembershipDues/PmdImportSJH');
const PmdAdditionalCharge = () => import('../pages/PartyMembershipDues/PmdAdditionalCharge');
const PmdExaminationImportNormal = () => import('../pages/PartyMembershipDues/PmdExaminationImportNormal');
const PmdExaminationImportAdd = () => import('../pages/PartyMembershipDues/PmdExaminationImportAdd');
const PmdExaminationImportAppend = () => import('../pages/PartyMembershipDues/PmdExaminationImportAppend');
const PmdControl = () => import('../pages/PartyMembershipDues/PmdControl');
const PmdAuditRecords = () => import('../pages/PartyMembershipDues/PmdAuditRecords');
const PmdTicketManage = () => import('../components/otherTicketManage');
const PmdChargeInfo = () => import('../pages/PartyMembershipDues/PmdChargeInfo');
const RightPanel = () => import('../components/RightPanel');
const PmdRefundDetail = () => import('../pages/PartyMembershipDues/PmdRefundDetail');
const CostProcess = () => import('../pages/PartyMembershipDues/CostProcess');
const CostPending = () => import('../pages/PartyMembershipDues/CostPending');

export default [
	{ path: '/PmdHomePage', name: 'PmdHomePage', component: PmdWrapper, meta: { type: 'partymembership' } },
	{
		path: '/PmdTab',
		component: PmdTab,
		children: [
			{ path: '/', name: 'PmdDetailsEmpty', component: PmdDetailsEmpty, meta: { parent: '/PmdHomePage' } },
			{ path: 'PmdProgress', name: 'PmdProgress', component: PmdChargeSchedule, meta: { parent: '/PmdHomePage' } },
			{ path: 'PmdControl', name: 'PmdControl', component: PmdControl, meta: { parent: '/PmdHomePage' } },
			{ path: 'PmdAuditRecords', name: 'PmdAuditRecords', component: PmdAuditRecords, meta: { parent: '/PmdHomePage' } },
			{ path: 'PmdTicketManage', name: 'PmdTicketManage', component: PmdTicketManage, meta: { parent: '/PmdHomePage' } },
		],
	},
	{ path: '/CostPending', name: 'CostPending', component: CostPending, meta: { type: 'partymembership' } },
	{ path: '/CostProcess', name: 'CostProcess', component: CostProcess, meta: { type: 'partymembership' } },
	{ path: '/PmdClearedList', name: 'PmdClearedList', meta: { type: 'partymembership' }, component: PmdClearedList },
	{ path: '/PmdRefund',
		name: 'PmdRefund',
		component: PmdRefund,
		children: [
			{
				path: '/PmdRefundRightPanel',
				name: 'PmdRefundRightPanel',
				meta: { parent: '/PmdHomePage' },
				component: RightPanel,
				children: [
					{
						path: '/PmdRefundDetail/:rowData',
						name: 'PmdRefundDetail',
						component: PmdRefundDetail,
						meta: { parent: '/PmdHomePage' },
					},
				],
			},
		] },
	{ path: '/PmdRefundRecord',
		name: 'PmdRefundRecord',
		component: PmdRefundRecord,
		children: [
			{
				path: '/PmdRefundRecordRightPanel',
				name: 'PmdRefundRecordRightPanel',
				meta: { parent: '/PmdHomePage' },
				component: RightPanel,
				children: [
					{
						path: '/PmdRefundRecordDetail/:rowData',
						name: 'PmdRefundRecordDetail',
						component: PmdRefundRecordDetail,
						meta: { parent: '/PmdHomePage' },
					},
				],
			},
		] },
	// { path: '/PmdRefundRecordDetail', name: 'PmdRefundRecordDetail', meta: { type: 'partymembership' }, component: PmdRefundRecordDetail },
	{ path: '/PmdDetailsTemplateIssue/:radio', name: 'PmdDetailsTemplateIssue', meta: { type: 'partymembership' }, component: PmdDetailsTemplateIssue },
	{ path: '/PmdImportXH', name: 'PmdImportXH', meta: { type: 'partymembership' }, component: PmdImportXH },
	{ path: '/PmdImportSJH', name: 'PmdImportSJH', meta: { type: 'partymembership' }, component: PmdImportSJH },
	{ path: '/PmdAdditionalCharge', name: 'PmdAdditionalCharge', meta: { type: 'partymembership' }, component: PmdAdditionalCharge },
	{ path: '/PmdExaminationImportNormal', name: 'PmdExaminationImportNormal', meta: { type: 'partymembership' }, component: PmdExaminationImportNormal },
	{ path: '/PmdExaminationImportAdd', name: 'PmdExaminationImportAdd', meta: { type: 'partymembership' }, component: PmdExaminationImportAdd },
	{ path: '/PmdExaminationImportAppend', name: 'PmdExaminationImportAppend', meta: { type: 'partymembership' }, component: PmdExaminationImportAppend },
	{ path: '/PmdChargeInfo/:fw', name: 'PmdChargeInfo', meta: { type: 'partymembership' }, component: PmdChargeInfo },
];
